import React from 'react'
import { Box, Button } from '@mui/material'

import { useDialog } from '../../../../hooks'

import { NewStaticC2BForm } from './new-static-c2b-form.tsx'
import { useAppSelector } from '@/stores/hooks.ts'

export const CreateStaticQrButton = (): React.ReactElement | null => {
  const showQrC2bStatic = useAppSelector((state) => state.user.user?.permissions?.showQrC2bStatic)
  const { showDialog, handleHideDialog, handleShowDialog } = useDialog()
  if (!showQrC2bStatic) return null

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button onClick={handleShowDialog}>Создать статический QR</Button>
      {showDialog && <NewStaticC2BForm open={showDialog} onClose={handleHideDialog} />}
    </Box>
  )
}
